export class Connector {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "connectorType",
            "baseName": "connectorType",
            "type": "ConnectorType",
            "format": ""
        },
        {
            "name": "connectorExternalId",
            "baseName": "connectorExternalId",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "ConnectorStatus",
            "format": ""
        },
        {
            "name": "awsAccountProperties",
            "baseName": "awsAccountProperties",
            "type": "ConnectorAwsAccountProperties",
            "format": ""
        },
        {
            "name": "gcpProjectProperties",
            "baseName": "gcpProjectProperties",
            "type": "ConnectorGcpProjectProperties",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return Connector.attributeTypeMap;
    }
    constructor() {
    }
}
